import type { i18n as I18nInstance } from 'i18next';

/** Clave raíz bajo la que se inyecta el contenido del cuestionario en el bundle i18n. */
export const QUESTIONNAIRE_KEY_ROOT = 'questionnaire';

/**
 * Clave i18n de la etiqueta de un paso, la que pinta el stepper. Sale del catálogo y no
 * de un literal en la definición del test para que la etiqueta viva en un solo sitio y
 * siga al idioma en que se pidió el cuestionario.
 */
export const stepLabelKey = (stepKey: string): string =>
  `${QUESTIONNAIRE_KEY_ROOT}.steps.${stepKey}.label`;

export interface InjectableContent {
  /**
   * Los pasos traen más que su clave —`label`, `title`, `intro`—; el inyector sólo
   * necesita la clave para indexarlos, pero el resto viaja y lo leen las vistas.
   */
  steps: ({ key: string } & Record<string, unknown>)[];
  questions: unknown;
}

/**
 * Inyecta el contenido del cuestionario recibido del EP en i18next bajo
 * `questionnaire.*` del namespace `translation`, sobrescribiendo lo previo. Los
 * `steps` se indexan por su `key` para poder leerlos con
 * `t('questionnaire.steps.<key>', { returnObjects: true })`.
 */
export const injectQuestionnaireContent = (
  instance: I18nInstance,
  language: string,
  content: InjectableContent,
): void => {
  const steps = Object.fromEntries(
    content.steps.map((step) => [step.key, step]),
  );

  instance.addResourceBundle(
    language,
    'translation',
    { [QUESTIONNAIRE_KEY_ROOT]: { steps, questions: content.questions } },
    true,
    true,
  );
};
